import { connect } from "react-redux"
import styledComponentConnection from "QuorumGrassroots/styled-components/selectors"

// this connects both organizationDesign and actionCenterSettings
function styleWithOrgDesign<T extends React.FC<any>>(component: T) {
    return connect(styledComponentConnection, {})(component)
}

export default styleWithOrgDesign
